import React, { ReactElement } from 'react';

import Skeleton from '../Skeleton/Skeleton';

import SectionIcon from '@/components/common/SectionIcon/SectionIcon';
import Heading from '../Heading/Heading';
import styles from './page-title.module.scss';

interface IPageTitleProps {
  title: string;
  expandingComponent?: ReactElement;
  isLoading?: boolean;
}

export default function PageTitle({ title, expandingComponent, isLoading }: IPageTitleProps) {
  return (
    <div className={styles['page-title']}>
      <div className="d-flex">
        <div className={styles['icon-wrapper']}>
          <SectionIcon />
        </div>

        <Heading
          level={1}
          className={styles.text}
        >
          {isLoading && (
            <Skeleton width="300px" />
          )}

          {!isLoading && title}
        </Heading>
      </div>

      {expandingComponent && (
        <div>
          {expandingComponent}
        </div>
      )}
    </div>
  );
}
